import React, { useState, useEffect } from "react";
import {
  MdOutlineSchedule,
  MdPersonOutline,
  MdGroups,
  MdPublic,
  MdGroup,
  MdCake,
  MdSend,
  MdPayments,
  MdPrivacyTip,
  MdAutorenew,
  MdArrowBack,
  MdDelete,
  MdMessage,
  MdSchedule,
  MdToday,
  MdWarningAmber
} from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { styles } from "../styles/SchedulePage.styles";
import { useAuth } from "../context/AuthContext";
import { getChats } from "../services/chat";
import Select from "react-select";
import { getTomadoresContact, getUtilizadoresContact } from "../services/Contacts";
import { getModelos, editarAgendamento, removeAgendamento } from "../services/agendamento";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";

function EditSchedulePage({ setActiveMenu, agendamento }) {
  const [type, setType] = useState("utilizador");
  const [message, setMessage] = useState("");
  const [conversations, setConversations] = useState([]);
  const [date, setDate] = useState("");
  const [faseCobranca, setFaseCobranca] = useState("ANTES");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const navigate = useNavigate();
  const [templatesCobranca, setTemplatesCobranca] = useState({
    ANTES: "",
    DIA: "",
    ATRASO: ""
  });

  const [isMobile, setIsMobile] = useState(
    typeof window !== "undefined" ? window.innerWidth < 768 : false
  );
  const { token, stampTomador } = useAuth();
  const [tomadores, setTomadores] = useState([]);
  const [utilizadores, setUtilizadores] = useState([]);
  const [modelos, setModelos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [hora, setHora] = useState("09:30");
  const faseOrder = ["ANTES", "DIA", "ATRASO"];
  const allowedFases = faseOrder.slice(
    faseOrder.indexOf(faseCobranca)
  );

  const currentIndex = faseOrder.indexOf(faseCobranca);
  const [initialFase, setInitialFase] = useState("ANTES");
  const initialIndex = faseOrder.indexOf(initialFase);

  const faseOptions = [
    {
      value: "ANTES",
      label: "Antes do vencimento",
      icon: MdSchedule
    },
    {
      value: "DIA",
      label: "Dia do vencimento",
      icon: MdToday
    },
    {
      value: "ATRASO",
      label: "Em atraso",
      icon: MdWarningAmber
    }
  ].filter(opt => faseOrder.indexOf(opt.value) >= initialIndex);


  const selectedOption =
  faseOptions.find(opt => opt.value === faseCobranca) || null;

  const resolveTemplateValue = (value) => {
    if (!value) return "";
    if (typeof value === "string") return value;
    if (typeof value === "object") return value.mensagem || value.MENSAGEM || "";
    return String(value);
  };

  const modeloOptions = modelos.map((m) => ({
    value: m.STAMP,
    label: m.TITULO,
    mensagem: m.MENSSAGEM,
    icon:
      m.TIPO === "A"
        ? MdCake
        : m.TIPO === "C"
        ? MdPayments
        : m.TIPO === "R"
        ? MdPrivacyTip
        : MdSend
  }));

  const formatModeloOption = ({ label, icon: Icon }) => (
    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
      {Icon && <Icon size={18} color="#6b7280" />}
      <span>{label}</span>
    </div>
  );

  // Carrega dados iniciais do agendamento
   useEffect(() => {
    if (!agendamento) {
      navigate("/agendar");
      return;
    }


    if (agendamento.CAMPANHA_NOME === "Cobranças") {
      try {
        let parsed =
          typeof agendamento.CONTEUDO === "string"
            ? JSON.parse(agendamento.CONTEUDO)
            : agendamento.CONTEUDO;


        const templates =
          parsed?.templates ??
          {
            ANTES: parsed?.ANTES || "",
            DIA: parsed?.DIA || "",
            ATRASO: parsed?.ATRASO || ""
          };


        setFaseCobranca(parsed?.fase || "ANTES");
        setInitialFase(parsed?.fase || "ANTES");


        setTemplatesCobranca({
          ANTES: resolveTemplateValue(templates.ANTES),
          DIA: resolveTemplateValue(templates.DIA),
          ATRASO: resolveTemplateValue(templates.ATRASO)
        });

      } catch (err) {
        console.error("Erro ao parsear cobrança:", err);
      }
    }else{
      setMessage(agendamento.CONTEUDO || "");
    }


    if (agendamento.DATA_AGEND) {
      const d = new Date(agendamento.DATA_AGEND);

      const local = new Date(d.getTime() - d.getTimezoneOffset() * 60000)
        .toISOString()
        .slice(0, 16);

      setDate(local);
    }
  }, [agendamento]);

  


  useEffect(() => {
    const fetchModelos = async () => {
      try {
        const data = await getModelos();
        setModelos(data?.agendamentos || []);
      } catch (err) {
        console.error("Erro ao buscar modelos:", err);
      }
    };

    fetchModelos();
  }, [token]);

  useEffect(() => {
    const style = document.createElement("style");
    style.innerHTML = `
      @keyframes spinModern {
        from { transform: rotate(0deg); }
        to { transform: rotate(360deg); }
      }

      .spin-modern {
        width: 18px;
        height: 18px;
        border-radius: 50%;
        border: 2px solid rgba(0,0,0,0.1);
        border-top: 2px solid #ebeaea;
        animation: spinModern 0.8s linear infinite;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  useEffect(() => {
    if (!token) return;

    const fetchConversations = async () => {
      try {
        const data = await getChats();
        setConversations(data);
      } catch (err) {
        console.error("Erro ao buscar conversas:", err);
      }
    };

    const fetchTomadores = async () => {
      try {
        const data = await getTomadoresContact();
        setTomadores(data || []);
      } catch (err) {
        console.error("Erro ao buscar tomadores:", err);
      }
    };

    const fetchUtilizadores = async () => {
      try {
        const data = await getUtilizadoresContact();
        setUtilizadores(data || []);
      } catch (err) {
        console.error(err);
      }
    };

    fetchConversations();
    fetchTomadores();
    fetchUtilizadores();
  }, [token]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleUpdate = async () => {

    /*
    if (!message || message.trim() === "") {
        return setError("Escreve uma mensagem");
    }
        */

    if (!date) {
        return setError("Seleciona data e hora de envio");
    }

    setLoading(true);

    let envio = new Date(date).toISOString();
    
    try {
      const response = await editarAgendamento(agendamento.STAMP, {
        CONTEUDO:
          agendamento?.CAMPANHA_NOME === "Cobranças"
            ? JSON.stringify({
                fase: faseCobranca,
                templates: templatesCobranca
              })
            : message,
        ENVIAR_EM: envio,
      });

      setLoading(false);

      if (!response || response.error || response.success === false) {
        console.error("Erro ao atualizar agendamento:", response?.error || response);
        setError("Não foi possível atualizar o agendamento. Tente novamente.");
        return;
      }

      navigate("/agendar");
    } catch (err) {
      setLoading(false);
      console.error("Erro ao atualizar agendamento:", err);
      setError("Não foi possível atualizar o agendamento. Tente novamente.");
    }
  };

  const handleDelete = async () => {
    setLoading(true);

    try {
      const response = await removeAgendamento(agendamento.STAMP);
      setLoading(false);

      if (!response || response.error || response.success === false) {
        console.error("Erro ao eliminar agendamento:", response?.error || response);
        setError("Não foi possível eliminar o agendamento. Tente novamente.");
        return;
      }

      navigate("/agendar");
    } catch (err) {
      setLoading(false);
      console.error("Erro ao eliminar agendamento:", err);
      setError("Não foi possível eliminar o agendamento. Tente novamente.");
    }
  };

  return (
    <div style={styles.page(isMobile)}>
      <div style={styles.headerRow(isMobile)}>
        <button
          onClick={() => navigate("/agendar")}
          style={{
            border: "none",
            background: "transparent",
            cursor: "pointer",
            marginRight: 10,
            display: "flex",
            alignItems: "center"
          }}
        >
          <MdArrowBack size={22} />
        </button>

        <div style={styles.iconBadge}>
          <MdOutlineSchedule size={22} />
        </div>

        <div>
          <h2 style={styles.title}>Editar Agendamento</h2>
          <p style={styles.subtitle}>
            Modifica os detalhes do agendamento.
          </p>
        </div>
      </div>

      <div style={styles.card(isMobile)}>
        <div style={styles.formGroup}>
          <label style={styles.label}>Destinatário</label>
          <div
            style={{
              ...styles.input,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              backgroundColor: "#f9fafb",
              padding: "12px 16px"
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              {agendamento?.DESTINO_FOTO ? (
                <img
                  src={agendamento.DESTINO_FOTO}
                  alt={agendamento?.DESTINO_NOME}
                  style={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    objectFit: "cover"
                  }}
                />
              ) : (
                <div style={{
                  width: 32,
                  height: 32,
                  borderRadius: "50%",
                  backgroundColor: "#e5e7eb",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}>
                  <MdGroup size={16} color="#6b7280" />
                </div>
              )}
              
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                {agendamento?.CAMPANHA_NOME === "Aniversário" ? (
                  <MdCake size={18} color="#f59e0b" />
                ) : agendamento?.CAMPANHA_NOME === "Cobranças" ? (
                  <MdPayments size={18} color="#dc2626" />
                ) : agendamento?.CAMPANHA_NOME === "Mensagem" ? (
                  <MdMessage size={18} color="#3b82f6" />
                ) : agendamento?.CAMPANHA_NOME === "Privacidade" ? (
                  <MdPrivacyTip size={18} color="#8b5cf6" />
                ) : (
                  <MdSend size={18} color="#10b981" />
                )}
                <span>{agendamento?.DESTINO_NOME}</span>
              </div>
            </div>
          </div>
          <span style={styles.helpText}>
            Destinatário não pode ser alterado.
          </span>
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>Mensagem</label>

          {agendamento?.CAMPANHA_NOME === "Cobranças" ? (
            <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>

              {/* SELECT FASE */}
              <Select
                options={faseOptions}
                value={selectedOption}
                onChange={(selected) => {
                  if (faseOrder.indexOf(selected.value) < initialIndex) return;
                  setFaseCobranca(selected.value);
                }}
                formatOptionLabel={formatModeloOption}
                styles={{
                  control: (base) => ({
                    ...base,
                    borderRadius: 8,
                    borderColor: "#ccc",
                    minHeight: 42,
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                }}
              />

              {/* TEXTO */}
              <textarea
                value={templatesCobranca[faseCobranca]}
                onChange={(e) =>
                  setTemplatesCobranca((prev) => ({
                    ...prev,
                    [faseCobranca]: e.target.value
                  }))
                }
                style={styles.textarea}
              />
            </div>
          ) : (
            <textarea
              placeholder="Escreve a tua mensagem..."
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              style={styles.textarea}
            />
          )}
        </div>

        <div style={styles.formGroup}>
          <label style={styles.label}>
            Data e hora de envio
          </label>
        
            <input
              type="datetime-local"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              style={styles.input}
            />
        </div>

        {error && (
          <div
            style={{
              background: "#fee2e2",
              color: "#b91c1c",
              padding: "10px 12px",
              borderRadius: 8,
              fontSize: 13,
              marginBottom: 10,
              border: "1px solid #fecaca"
            }}
          >
            {error}
          </div>
        )}

        <div
          style={{
            display: "flex",
            gap: 8,
            justifyContent: "flex-end"
          }}
        >
          <button
            type="button"
            onClick={() => setShowDeleteModal(true)}
            disabled={loading}
            style={{
              ...styles.submitButton,
              background: "#dc2626",
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8
            }}
          >
            <MdDelete size={18} />
            Eliminar
          </button>

          <button
            type="button"
            onClick={handleUpdate}
            disabled={loading}
            style={{
              ...styles.submitButton,
              opacity: loading ? 0.7 : 1,
              cursor: loading ? "not-allowed" : "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 8
            }}
          >
            {loading ? (
              <>
                <div className="spin-modern" />
                A guardar...
              </>
            ) : (
              "Guardar alterações"
            )}
          </button>
        </div>
      </div>

      <ConfirmDeleteModal
        open={showDeleteModal}
        loading={loading}
        itemName={agendamento?.DESTINO_NOME}
        message="Tem a certeza que deseja eliminar este agendamento?"
        onCancel={() => setShowDeleteModal(false)}
        onConfirm={handleDelete}
      />
    </div>
  );
}

export default EditSchedulePage;
